import './template-collection.scss';
import { atQuery } from '../../scripts/components/mediaQueries';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  // Manage grid view switch

  document.querySelectorAll('[grid-settings-wrapper] .filters-viewer-params .col-view').forEach(colView => {
    colView.addEventListener('click', () => {
      const cols = colView.getAttribute('data-col');

      document.querySelectorAll('[grid-settings-wrapper] .filters-viewer-params .col-view').forEach(col => {
        col.classList.remove('current');
      });

      colView.classList.add('current');

      const gridSettingsWrapper = document.querySelector('[grid-settings-wrapper]');

      gridSettingsWrapper.className = '';
      gridSettingsWrapper.classList.add(`grid-${cols}-col`);
    });
  });

  atQuery('max', 'md', () => {
    document.querySelector('[grid-settings-wrapper]').classList.remove('grid-1-col');
    document.querySelectorAll('[grid-settings-wrapper] .filters-viewer-params .col-view').forEach(colView => {
      colView.classList.remove('current');
    });
    document.querySelector('[grid-settings-wrapper]').classList.add('grid-2-col');
    document.querySelector('[grid-settings-wrapper] .filters-viewer-params.view__mobile [data-col="2"]').classList.add('current');
  });

  atQuery('min', 'md', () => {
    document.querySelector('[grid-settings-wrapper]').classList.remove('grid-2-col');
    document.querySelector('[grid-settings-wrapper]').classList.remove('grid-1-col');
  });

  // Manage filters drawer opening/closing

  const filtersOpener = templateCollectionSection.querySelector('.filters-opener');
  const filtersContainer = templateCollectionSection.querySelector('.filters__container');
  const filterClose = templateCollectionSection.querySelector('.filters-drawer__close');
  if (filtersOpener && filtersContainer) {
    filtersOpener.addEventListener('click', function () {
      filtersContainer.classList.add('open');
      document.querySelector('html').style.overflow = 'hidden';
    });

    if (filterClose) {
      filterClose.addEventListener('click', () => {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
      });
    }

    var closeOnMouseUp = false;
    filtersContainer.addEventListener('mousedown', (e) => {
      if (!filtersContainer.classList.contains('open') || e.target.classList.contains('filters-drawer__content') || e.target.closest('.filters-drawer__content') || e.target.classList.contains('filters-drawer__active-filters__filter') || e.target.closest('.filters-drawer__active-filters__filter')) return;
      closeOnMouseUp = true;
    });

    filtersContainer.addEventListener('mouseup', () => {
      if (closeOnMouseUp) {
        filtersContainer.classList.remove('open');
        document.querySelector('html').style.overflow = '';
        closeOnMouseUp = false;
      }
    });
  }

  // Manage active filters' tags

  templateCollectionSection.querySelectorAll('#FacetFiltersForm .js-filter input[type="checkbox"]').forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      const filterContainer = checkbox.closest('[data-filter]');
      if (filterContainer) {
        const counterLabels = document.querySelectorAll(`#FacetFiltersForm [data-filter="${filterContainer.dataset.filter}"] [single-filter-active-counter]`);
        const checkedCounters = filterContainer.querySelectorAll('input[type="checkbox"]:checked').length;

        if (counterLabels.length > 0) {
          counterLabels.forEach(counterLabel => {
            counterLabel.innerText = `(${checkedCounters})`;

            if (checkedCounters <= 0) {
              counterLabel.style.display = 'none';
            } else {
              counterLabel.style.display = '';
            }
          });
        }
      }
    });
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
